export const GET_ALL_STORES = 'GET_ALL_STORES';
export const GET_TEMPLATE_STORES = 'GET_TEMPLATE_STORES';
export const SET_STORE_URL = 'SET_STORE_URL';
export const SET_CURRENT_STORE = 'SET_CURRENT_STORE';
export const EDIT_STORE = 'EDIT_STORE';
export const UPDATE_STORE_EMAIL = 'UPDATE_STORE_EMAIL';
export const SET_APPAREL_SIZES = 'SET_APPAREL_SIZES';
